import { c as _c } from "react/compiler-runtime";
import { logout, useJwtToken } from "@website/hooks/auth-manager";
import { MaterialIcon } from "@website/icons/material";
import { Avatar } from "@website/ui/avatar";
import { Sheet } from "@website/ui/sheet";
import { Skeleton } from "@website/ui/skeleton";
import { isChannel } from "@website/utils/channel/helpers";
import { numberConvert } from "@website/utils/number-convert";
import profileImage from "../../assets/avatar.svg";
import { ProfileMenuItem } from "./components/profile-menu-item";
import { useGetBalance } from "./services/get-balance-service";
interface Properties {
  isOpen: boolean;
  close: () => void;
}
export function ProfileMenu(t0) {
  const $ = _c(34);
  const {
    isOpen,
    close
  } = t0;
  const {
    name: fullName,
    phoneNumber
  } = useJwtToken();
  const {
    balance: t1,
    isLoadingGetBalance
  } = useGetBalance();
  const {
    balance
  } = t1;
  const onClickHandler = _temp;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function onLogout() {
      logout();
      window.location.href = "/";
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const onLogout = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = isChannel(["telesale"]);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isTeleSalesChannel = t3;
  let t4;
  if ($[2] !== balance || $[3] !== isLoadingGetBalance) {
    t4 = isTeleSalesChannel ? [] : [{
      label: "\u06A9\u06CC\u0641 \u067E\u0648\u0644",
      value: isLoadingGetBalance ? <Skeleton width={100} height={20} /> : `${numberConvert(((balance || 0) / 10).toLocaleString(), {
        locale: "fa"
      })} تومان`,
      icon: <MaterialIcon name="account_balance_wallet" variant="outlined" />,
      onClick: () => onClickHandler("/profile/wallet")
    }];
    $[2] = balance;
    $[3] = isLoadingGetBalance;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      label: "\u0644\u06CC\u0633\u062A \u0645\u0633\u0627\u0641\u0631\u0627\u0646",
      icon: <MaterialIcon name="people" variant="outlined" />,
      onClick: () => onClickHandler("/profile/passengers-list")
    };
    t6 = isTeleSalesChannel ? [] : [{
      label: "\u0644\u06CC\u0633\u062A \u062A\u0631\u0627\u06A9\u0646\u0634 \u0647\u0627",
      value: "",
      icon: <MaterialIcon name="history" variant="outlined" />,
      onClick: () => onClickHandler("/profile/transactions")
    }];
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      label: "\u062E\u0631\u0648\u062C",
      icon: <MaterialIcon name="logout" />,
      onClick: onLogout
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t4) {
    t8 = [...t4, t5, ...t6, t7];
    $[8] = t4;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const profileList = t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Avatar src={profileImage.src} className="size-12 max-h-12 min-w-12" size="large" type="image" variant="circular" />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = fullName || "\u0646\u0627\u0645 \u06A9\u0627\u0631\u0628\u0631";
  let t11;
  if ($[11] !== t10) {
    t11 = <div className="text-subtitle-2 text-on-surface-high-emphasis">{t10}</div>;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== phoneNumber) {
    t12 = numberConvert(phoneNumber?.replaceAll?.("+98", "0"), {
      locale: "fa"
    });
    $[13] = phoneNumber;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12) {
    t13 = <p className="text-extra-caption text-on-surface-high-emphasis">{t12}</p>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t11 || $[18] !== t13) {
    t14 = <div>{t11}{t13}</div>;
    $[17] = t11;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== close) {
    t15 = <MaterialIcon name="chevron_left" onClick={close} className="mr-auto" />;
    $[20] = close;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t14 || $[23] !== t15) {
    t16 = <a href="/profile/information" className="flex items-center gap-4 px-6 py-2">{t9}{t14}{t15}</a>;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== profileList) {
    t17 = profileList.map(_temp2);
    $[25] = profileList;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t16 || $[28] !== t17) {
    t18 = <div className="min-w-[312px] py-3">{t16}{t17}</div>;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== close || $[31] !== isOpen || $[32] !== t18) {
    t19 = <Sheet onClose={close} open={isOpen} xGap="16px" xPosition="end" yPosition="end">{t18}</Sheet>;
    $[30] = close;
    $[31] = isOpen;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  return t19;
}
function _temp2(item) {
  return <ProfileMenuItem key={item.label} {...item} />;
}
function _temp(pathname) {
  if (typeof window !== "undefined") {
    window.location.href = pathname;
  }
}